var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { Overlay as BPOverlay } from '@blueprintjs/core';
export const Overlay = (_a) => {
    var { openState, children, classes } = _a, props = __rest(_a, ["openState", "children", "classes"]);
    const overlayClasses = cx('overlay', classes);
    return (React.createElement(BPOverlay, Object.assign({ isOpen: openState, transitionDuration: 200, transitionName: "overlay_transition", backdropClassName: "overlay_backdrop" }, props),
        React.createElement("div", { className: "overlay_wrapper" },
            React.createElement("div", { className: overlayClasses }, children))));
};
//# sourceMappingURL=Overlay.js.map